const filters = {
  "Forms and sizes": {
    icon: "sizesAndForming.png",
    type: "checkbox-forms-sizes",
    datas: [
      {
        filterName: "Strips & Rolled products",
        technicalId: "stripsAndRolledProducts",
        checked: false
      },
      {
        filterName: "Wires (from 0.1mm diam.)",
        technicalId: "wireForm",
        checked: false
      },
      {
        filterName: "Rods (1 mm to 50 mm diam.)",
        technicalId: "rodForm",
        checked: false
      },
      {
        filterName: "Bars (15 mm to 300 mm diam.)",
        technicalId: "barForm",
        checked: false
      },
      {
        filterName: "Tubes & Hollow Bars",
        technicalId: "tubesAndHollowBars",
        checked: false
      },
      {
        filterName: "Special profiles",
        technicalId: "specialProfiles",
        checked: false
      }
    ]
  },
  "Mechanical properties": {
    icon: "mechanicalProperties.png",
    type: "slider",
    datas: [
      {
        filterName: "Yield Strength - Rp0,2",
        technicalId: ["yieldStrengthMPa", "yieldStrengthKsi"],
        unit: [
          { name: "MPa", valueMin: 0, valueMax: 1200, operator: "divide" },
          { name: "ksi", valueMin: 0, valueMax: 175, operator: "multiply" }
        ],
        selectedUnit: false,
        min: 0,
        max: 1200.0,
        selectedValue: 0,
        interval: 1,
        coefficient: 0.145038
      },
      {
        filterName: "Tensile Strength - Rm",
        technicalId: ["tensileStrengthMPa", "tensileStrengthKsi"],
        unit: [
          { name: "MPa", valueMin: 0, valueMax: 1200, operator: "divide" },
          { name: "ksi", valueMin: 0, valueMax: 175, operator: "multiply" }
        ],
        selectedUnit: false,
        min: 0,
        max: 1200,
        selectedValue: 0,
        coefficient: 0.145038
      },
      {
        filterName: "Elongation (%)",
        technicalId: "elongation",
        min: 0,
        max: 100,
        selectedValue: 0
      },
      {
        filterName: "Hardness",
        technicalId: ["hardnessHV", "hardnessHB"],
        unit: [
          { name: "HV", valueMin: 0, valueMax: 750 },
          { name: "HB", valueMin: 0, valueMax: 610 }
        ],
        selectedUnit: false,
        min: 0,
        max: 750,
        selectedValue: 0
      }
    ]
  },
  "Physical properties": {
    icon: "physicalProperties.png",
    type: "slider",
    datas: [
      {
        filterName: "Electrical Conductivity",
        technicalId: ["electricalConductivityIACS", "electricalConductivityMS"],
        unit: [
          {
            name: "IACS %",
            valueMin: 0,
            valueMax: 100,
            operator: "divide"
          },
          { name: "mS/m", valueMin: 0, valueMax: 60, operator: "multiply" }
        ],
        selectedUnit: false,
        min: 0,
        max: 100,
        selectedValue: 0.0,
        interval: 1,
        coefficient: 0.6
      },
      {
        filterName: "Thermal Conductivity (W/m/K)",
        technicalId: "thermalConductivity",
        min: 0,
        max: 400,
        selectedValue: 0,
        interval: 1
      },
      {
        filterName: "Density (g/cm³)",
        technicalId: "density",
        min: 0.0,
        max: 10.0,
        selectedValue: 0.0,
        interval: 0.01
      }
    ]
  },
  "Alloys clusters": {
    icon: "picto-univers.png",
    type: "univers-selection",
    datas: [
      {
        filterName: "Corrosion",
        technicalId: "NACECorrosion",
        value: []
      },
      {
        filterName: "Friction",
        technicalId: "friction",
        value: []
      }
    ]
  },
  "Surface properties": {
    icon: "surfaceProperties.png",
    type: "select",
    datas: [
      {
        filterName: "Corrosion",
        technicalId: "NACECorrosion",
        value: []
      },
      {
        filterName: "Friction",
        technicalId: "friction",
        value: []
      }
    ]
  }
};

export default filters;
